import i18next from 'i18next';
import React, { Suspense, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { WHITEBOARD_UI_OPTIONS } from '../../constants';
import { getStorageBackendUrl } from '../../functions';
const LazyExcalidrawApp = React.lazy(async () => {
    const [{ ExcalidrawApp }] = await Promise.all([
        import(/* webpackChunkName: "excalidraw" */ '@jitsi/excalidraw'),
        import(/* webpackChunkName: "excalidraw" */ '@jitsi/excalidraw/index.css')
    ]);
    return { default: ExcalidrawApp };
});
/**
 * Whiteboard wrapper for mobile.
 *
 * @returns {JSX.Element}
 */
const WhiteboardWrapper = ({ className, collabDetails, collabServerUrl, localParticipantName }) => {
    const excalidrawAPIRef = useRef(null);
    const collabAPIRef = useRef(null);
    const storageBackendUrl = useSelector(getStorageBackendUrl);
    const jwt = useSelector((state) => state['features/base/jwt']).jwt || '';
    const getExcalidrawAPI = useCallback(excalidrawAPI => {
        if (excalidrawAPIRef.current) {
            return;
        }
        excalidrawAPIRef.current = excalidrawAPI;
    }, []);
    const getCollabAPI = useCallback(collabAPI => {
        if (collabAPIRef.current) {
            return;
        }
        collabAPIRef.current = collabAPI;
        collabAPIRef.current.setUsername(localParticipantName);
    }, [localParticipantName]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: 'excalidraw-wrapper' },
            React.createElement(Suspense, { fallback: null },
                React.createElement(LazyExcalidrawApp, { collabDetails: collabDetails, collabServerUrl: collabServerUrl, excalidraw: {
                        isCollaborating: true,
                        langCode: i18next.language,
                        theme: 'light',
                        UIOptions: WHITEBOARD_UI_OPTIONS
                    }, getCollabAPI: getCollabAPI, getExcalidrawAPI: getExcalidrawAPI, jwt: jwt, storageBackendUrl: storageBackendUrl })))));
};
export default WhiteboardWrapper;
